import { render, staticRenderFns } from "./ed-class-builder-placeholder-block.component.vue?vue&type=template&id=72e536d6&scoped=true&"
import script from "./ed-class-builder-placeholder-block.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-builder-placeholder-block.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-builder-placeholder-block.component.scss?vue&type=style&index=0&id=72e536d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e536d6",
  null
  
)

export default component.exports